const Education = () => {
  const educationData = [
    {
      degree: "Bachelors of Science in Computer Science - BS(CS)",
      institution: "Air University Islamabad, Pakistan",
      years: "2020 - 2024",
    },
    {
      degree: "Govt Post Graduate College Jampur (Rajanpur) (HSSC)",
      institution: "BISE Dera Ghazi Khan",
      years: "2018 - 2020",
    },
  ];

  return (
    <div className="text-white bg-black py-24" id="education">
      <div className="container mx-auto px-4 sm:px-8 md:px-16 lg:px-24">
        <h2 className="text-4xl sm:text-5xl mt-6 font-bold text-center mb-16 bg-gradient-to-r from-purple-800 to-purple-400 bg-clip-text text-transparent">
          Education
        </h2>
        
        <div className="space-y-12 max-w-4xl mx-auto">
          {educationData.map((edu, index) => (
            <div key={index} className="bg-gray-800 border-2 border-purple-800 rounded-xl p-6 sm:p-8 hover:shadow-xl hover:shadow-purple-600/20 transition-all duration-300">
              <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
                <div className="space-y-2">
                  <h2 className="text-2xl sm:text-3xl lg:text-2xl font-bold">{edu.degree}</h2>
                  <p className="text-lg sm:text-xl text-gray-400">{edu.institution}</p>
                  <p className="text-purple-500 font-semibold">{edu.grade}</p>
                </div>
                <div className="bg-purple-900/50 px-4 py-2 rounded-full text-base sm:text-lg whitespace-nowrap">
                  {edu.years}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Education;
